'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseApi = function () {
  _createClass(BaseApi, null, [{
    key: 'EMARSYS',
    get: function get() {
      return 'EMARSYS';
    }
  }]);

  function BaseApi(transmitter) {
    _classCallCheck(this, BaseApi);

    this.transmitter = transmitter;
  }

  _createClass(BaseApi, [{
    key: 'getRandomId',
    value: function getRandomId() {
      return Math.floor(Math.random() * 10000000);
    }
  }, {
    key: 'exposeMethods',
    value: function exposeMethods(methodList) {
      var _this = this;

      return methodList.reduce(function (memo, methodName) {
        memo[methodName] = _this[methodName].bind(_this);
        return memo;
      }, {});
    }
  }]);

  return BaseApi;
}();

module.exports = BaseApi;


/*****************
 ** WEBPACK FOOTER
 ** /home/runner/work/emarsys-integration-js/emarsys-integration-js/~/emarsys-integration-client/dist/client/base_api.js
 ** module id = 5
 ** module chunks = 0 1
 **/